import {Injectable} from "@angular/core";
import {Subject} from "rxjs";
import {UserWallet} from "../models/User/user-wallet";
import {TransactionStatusEmitter} from "../models/Payment/Emitters/transaction-status-emitter";

@Injectable()
export class WalletService {
    public readonly $walletReadyEmitter: Subject<any>;
    public readonly $creditCardReadyEmitter: Subject<any>;
    public readonly $transactionProgress: Subject<TransactionStatusEmitter>;
    public readonly $transactionFinish: Subject<boolean>;

    private selectedInvoice: any;
    private selectedWallet: UserWallet;
    public amountOfTransaction: number;

    static _() {
        return new WalletService();
    }

    constructor() {
        this.$walletReadyEmitter = new Subject();
        this.$creditCardReadyEmitter = new Subject();
        this.$transactionProgress = new Subject<TransactionStatusEmitter>();
        this.$transactionFinish = new Subject();
    }

    selectInvoice(invoice: any): void {
        this.selectedInvoice = invoice;
    }

    selectWallet(wallet: UserWallet): void {
        this.selectedWallet = wallet;
    }

    getInvoice() {
        return this.selectedInvoice;
    }

    emitCreditCardReady(): void {
        this.$creditCardReadyEmitter.next(true);
    }

    emitWalletReady(): void {
        this.$walletReadyEmitter.next(true);
    }

    // * Check if transaction OK or not
    emitTransactionProgress(transactionDetail?: TransactionStatusEmitter): void {
        // TODO: Should watch this part
        this.selectedInvoice = null;
        this.selectedWallet = undefined;
        this.$transactionProgress.next(transactionDetail);
    }

    emitTransactionFinish(isSuccess: boolean): void {
        this.$transactionFinish.next(isSuccess);
    }
}
